import { MentionsInputStyled } from '@procurify/ui'
import { em, rem } from 'polished'
import styled from 'styled-components'

interface IChatInputContainerStyledProps {}

export const ChatInputContainerStyled = styled.div<IChatInputContainerStyledProps>`
  font-size: ${rem(12)};

  background-color: ${(props) => props.theme.colors.offwhite};

  padding: 0.5em;

  ${MentionsInputStyled} {
    width: auto;
  }

  .mentions-input-placeholder {
    width: 100%;
    height: ${em(100, 12)};

    font-family: 'Inter', sans-serif;
    line-height: 1.42;
    outline: none;
    padding: ${em(12, 12)} ${em(15, 12)};
    tab-size: 4;
    text-align: left;

    font-style: italic;

    background: ${(props) => props.theme.colors.lightGrey};
    font-weight: ${(props) => props.theme.fontWeights.normal};
    border-radius: ${rem(4)};
    border: 1px solid ${(props) => props.theme.colors.content.border};
    margin: 0;
  }
`
